import { render, staticRenderFns } from "./wcsd_details.vue?vue&type=template&id=2dd1abff&scoped=true&"
import script from "./wcsd_details.vue?vue&type=script&lang=js&"
export * from "./wcsd_details.vue?vue&type=script&lang=js&"
import style0 from "./wcsd_details.vue?vue&type=style&index=0&id=2dd1abff&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dd1abff",
  null
  
)

export default component.exports